import React from "react";
import { Link } from "react-router-dom";

const FooterSubCategories = () => {
  return (
    <div className="bg-[#003f97] block pt-8 pb-5 md:pb-[10rem] text-white border-b-2 border-[#ffffff50]">
      <div className=" grid grid-cols-2 md:grid-cols-5 gap-3 w-[95%] mx-auto">
        <ul className=" flex-wrap flex flex-col  gap-2 ">
          <li>
            <Link className="footer__link" to="/rapport-evenment">
              Compte-rendus des événements passés
            </Link>
          </li>
          <li>
            <Link className="footer__link" to="/conferences">
              Conférence
            </Link>
          </li>
          <li>
            <Link className="footer__link" to="/politique-de-confidentialite">
              Politique de confidentialité
            </Link>
          </li>
        </ul>
        <ul className=" flex flex-col space-y-2 ">
          <li>
            <Link to="/contactez-nous" className="footer__link">
              Contact
            </Link>
          </li>
          <li>
            <Link className="footer__link" to="/don">
              Don
            </Link>
          </li>
          <li>
            <Link className="footer__link" to="/experts">
              Cartographie
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FooterSubCategories;
